import React from 'react';
import { Layers } from 'lucide-react';
import { Form1008Data } from '../types';
import { calculateMetrics } from '../utils/calculations';
interface Props {
  data: Form1008Data;
}
function formatCurrency(value: number) {
  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
}
export function LoanSnapshot({
  data
}: Props) {
  const metrics = calculateMetrics(data);
  const rows: {
    label: string;
    value: string;
  }[] = [{
    label: 'Program',
    value: data.program || '—'
  }, {
    label: 'Note Rate',
    value: data.noteRate ? `${data.noteRate}%` : '—'
  }, {
    label: 'Loan Amount',
    value: data.loanAmount ? `$${data.loanAmount.toLocaleString()}` : '—'
  }, {
    label: 'P&I (monthly)',
    value: formatCurrency(metrics.firstMortgagePI)
  }, {
    label: 'PITIA',
    value: formatCurrency(metrics.totalHousing)
  }, {
    label: 'LTV',
    value: `${metrics.ltv.toFixed(1)}%`
  }, {
    label: 'DSCR',
    value: `${metrics.dscr.toFixed(4)}×`
  }, {
    label: 'Rep. Score',
    value: data.repCreditScore ? String(data.repCreditScore) : '—'
  }];
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-54">
      <div className="px-5 py-4 flex items-center justify-between border-b border-slate-200" data-id="element-55">
        <div className="flex items-center gap-2" data-id="element-56">
          <Layers className="w-5 h-5 text-slate-500" data-id="element-57" />
          <h2 className="font-semibold text-slate-900" data-id="element-58">Loan Snapshot</h2>
        </div>
        <span className="px-2 py-0.5 text-[10px] font-semibold tracking-wide uppercase bg-slate-100 text-slate-500 rounded" data-id="element-59">
          From LOS
        </span>
      </div>
      <dl className="divide-y divide-slate-100" data-id="element-60">
        {rows.map(row => <div key={row.label} className="flex items-center justify-between px-5 py-3" data-id="element-61">
            <dt className="text-sm text-slate-500" data-id="element-62">{row.label}</dt>
            <dd className="text-sm font-bold text-slate-900 text-right" data-id="element-63">
              {row.value}
            </dd>
          </div>)}
      </dl>
    </div>;
}